var product_selected = {};

function isEmpty(val) {
    return (val === undefined || val == null || val.length <= 0) ? true : false;
}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    var ret = decodeURIComponent(results[2].replace(/\+/g, " "));

    return ret;
}

(function($) {

    // youtube placeholders
    if(typeof lazyYT_api_key !== 'undefined') {
        $('.lazyYT').lazyYT(lazyYT_api_key);
    }

    // lazy loading setup
    var bLazy = new Blazy({
        breakpoints: [{ width: 739, src: 'data-src-small' }],
        offset: 400
    });
    function doLazyReval() {
        bLazy.revalidate();
        if (!$('.b-lazy:not(.b-loaded)').length) $(window).off('resize', doLazyReval);
    }
    $(window).on('resize', doLazyReval);
    $(window).on('resize', checkIfSlickNeeded);

    // product page variables
    var $productImageSet        = $('.js-product-image-set');
    var $activeImageSet         = $();

    function checkIfSlickNeeded() {
        if (window.matchMedia('screen and (max-width: 739px)').matches) {

            // if there are no dynamic image sets to cycle through, set $activeImageSet
            if (!$productImageSet.length) {
                $activeImageSet = $('.product-image-grid');
            }

            if (!$activeImageSet.hasClass('slick-initialized')) {

                $activeImageSet.on('lazyLoaded', function(){
                    /* Remove broken implementation of aria tags */
                    $(".slick-slide").removeAttr('aria-describedby');
                    $(".slick-dots").removeAttr('role');
                    $(".slick-dots li").removeAttr('role').removeAttr('aria-controls').removeAttr('aria-selected');
                });
                $activeImageSet.slick({
                    adaptiveHeight: true,
                    lazyLoad: 'ondemand',
                    mobileFirst: true,
                    arrows: false,
                    dots: true,
                    responsive: [{ breakpoint: 740, settings: 'unslick' }]
                });

            }
        } else {
            doLazyReval();
        }
    }


    window.showImagesForPidSelected = function(pid) {
        // do we have dynamic images to cycle through?
        if ($productImageSet.length) {

            // if old image set exists and is slick initialized, undo it now
            if ($activeImageSet.length && $activeImageSet.hasClass('slick-initialized')) {
                $activeImageSet.slick('unslick');
            }

            $activeImageSet = $productImageSet.filter('[data-pid="' + pid + '"]').removeClass('hide');
            $productImageSet.filter('[data-pid!="' + pid + '"]').addClass('hide');

            // if on mobile, and if slick not initialized, do it now
            checkIfSlickNeeded();

        } else {
            // even if there are not dynamic images to cycle through,
            // we still need to check if Slick needs configuring
            checkIfSlickNeeded();
        }
    }
})(jQuery);














